/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { Record } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import TransactionEvent from '../../event/TransactionEvent'

class CreateViewState extends Record({
  accommodation_fee_paid: false,
  accommodation_tax_paid: false,
  others_paid: false
}) {}

class CreateViewStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new CreateViewState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case TransactionEvent.fetchReservation:
        // 初回ロード時
        return state.clear()

      case TransactionEvent.onEdit:
        return state.set(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new CreateViewStore()
